import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle2, Award, Target, Heart, Users } from 'lucide-react';
import { siteInfo, whyChooseUs } from '../data/mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Over Nobel Rijschool</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Jouw partner in het behalen van je rijbewijs. Persoonlijke begeleiding voor elke leerling, vanaf dag één.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1578041262130-633307b3bfd6?w=800&q=80"
                alt="Driving school"
                className="rounded-lg shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Ons Verhaal</h2>
              <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
                <p>
                  Nobel Rijschool is opgericht met één doel: jou op een persoonlijke en betrouwbare manier begeleiden naar je rijbewijs. Met de ervarende en één toegewijde instructeur zorgen we ervoor dat iedere leerling stap voor stap vertrouwen krijgt achter het stuur.
                </p>
                <p>
                  Bij ons krijg je persoonlijke aandacht, geduld en een positieve leeromgeving, zodat autorijden leren leuk en ontspannen blijft. Omdat alles door één instructeur wordt begeleid, leer je in een consistente en vertrouwde stijl.
                </p>
                <p>
                  Het mooiste moment voor ons? De glimlach op het gezicht van onze leerlingen wanneer ze slagen. Bij Nobel Rijschool draait alles om jouw succes en comfort op de weg
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Onze Waarden</h2>
            <p className="text-xl text-gray-600">Waar wij voor staan</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="border-none shadow-lg text-center">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Kwaliteit</h3>
                <p className="text-gray-600">
                  Wij leveren hoogwaardige rijlessen met ervaren en gecertificeerde instructeurs.
                </p>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg text-center">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Persoonlijk</h3>
                <p className="text-gray-600">
                  Elke leerling is uniek. We passen onze aanpak aan jouw behoeften aan.
                </p>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg text-center">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Resultaat</h3>
                <p className="text-gray-600">
                  Jouw succes is ons doel. We werken samen tot je geslaagd bent.
                </p>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg text-center">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Toegankelijk</h3>
                <p className="text-gray-600">
                  Flexibele planning en eerlijke prijzen maken ons toegankelijk voor iedereen.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Waarom Nobel Rijschool?</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {whyChooseUs.map((reason, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                  <span className="text-gray-700 text-lg">{reason}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Instructors */}
      {/* <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Onze Instructeurs</h2>
            <p className="text-xl text-gray-600">Ervaren professionals die jou naar succes begeleiden</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                name: "Jan Bakker",
                role: "Hoofdinstructeur",
                image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
                experience: "20 jaar ervaring"
              },
              {
                name: "Lisa de Vries",
                role: "Rijinstructeur",
                image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80",
                experience: "12 jaar ervaring"
              },
              {
                name: "Mark Jansen",
                role: "Rijinstructeur",
                image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80",
                experience: "15 jaar ervaring"
              }
            ].map((instructor, index) => (
              <Card key={index} className="border-none shadow-lg overflow-hidden">
                <img
                  src={instructor.image}
                  alt={instructor.name}
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{instructor.name}</h3>
                  <p className="text-blue-600 font-medium mb-2">{instructor.role}</p>
                  <p className="text-gray-600 text-sm">{instructor.experience}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPage;